<template>
  <div v-bind:class="['my-4 ma-md-5 mx-lg-10 mx-xl-10 maxw-1750', {
    'px-4': !$vuetify.breakpoint.mdAndUp,
  }]">
    <h2 class="pb-2"> {{ $t('views.news.title') }}</h2>

    <!-- Vacio -->
    <v-card
      v-if="!loading && !items.length"
      class="mt-4"
    >
      <v-card-text class="text-subtitle-2">{{ $t('views.news.empty') }}</v-card-text>
    </v-card>

    <template v-if="items.length">
      <ListItem
        v-for="(item, i) in items"
        :key="i"
        :url="url(item)"
      >
        <div slot="title" class="continaer__news">
            <div class="d-inline notification--title textEllipsis containerTitle">
              <span class="spanTitle">{{ item.name }}</span>
              <span class="spanSummary">{{ item.summary }}</span>
              <span class="spanCreationDate">Publicado el{{ parseDate(item.creationDate) }}</span>
            </div>

            <div class="notification-card-icon">
              <v-btn
                width="24"
                height="24"
                class="mr-2 shareBtn"
                icon
                @click.prevent="$event => share($event, item)"
              >
                <v-icon color="primary">mdi-share-variant</v-icon>
              </v-btn>
            </div>
        </div>
      </ListItem>
    </template>

    <!-- Loading -->
    <template v-if="loading">
      <v-card class="mt-4 py-2">
        <v-skeleton-loader
          type="list-item-avatar"
          class="mx-auto"
        ></v-skeleton-loader>
      </v-card>
    </template>

    <!-- Ver más -->
    <div class="text-center">
      <slot name="viewMore">
        <v-divider />
        <v-btn
          class="my-1"
          disabled
          @click="(e) => viewMore(e)"
          color="primary"
          text
        >
          {{ $t("components.searchBox.viewMore") }}
        </v-btn>
      </slot>
    </div>

    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>

import { ShareDialog, ListItem } from '@/components';

export default {
  props: {
    loading: Boolean,
    type: String,
    bussinessType: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    lastSearchArgs: {
      type: Object,
      default: () => ({}),
    },
    isPagination: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    sharedItem: null,
    sharedDialogPosition: {},
    openDialog: false,
    pathname: null,
  }),
  components: {
    ShareDialog,
    ListItem,
  },
  methods: {
    url(item) {
      return `/news/${item.id}`;
    },
    parseDate(date) {
      const creationDate = new Date(new Date(date * 1000).toISOString());
      return ` ${creationDate.getDate()}/${creationDate.getMonth() + 1}/${creationDate.getFullYear()} ${creationDate.getHours()}:${creationDate.getMinutes()}:${creationDate.getSeconds()}`;
    },
    search() {
      if (!this.loading) {
        this.$emit('request', {
          type: 'list',
        });
      }
    },
    share(evt, item) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      // TODO: Esta url pertenece no es propia de noticias, debe ser propia?
      const knowledgeUrl = item?.zVisibleInternet === 1 || item?.zVisibleInternet === null ? 'public/news/' : 'news/';
      const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}${knowledgeUrl}${item.id}`;

      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.noticeItem'),
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t('components.share.subjectBody.notice')} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };
        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
  },
  mounted() {
    this.search();
  },
};
</script>

<style lang="scss" scoped>
  .notification--title {
    font-size: 1rem;
  }
  .continaer__news {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.5rem;
  }
  .containerTitle{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-right: 1rem;
  }
  .spanCreationDate{
    display: block;
    font-size: 0.7rem;
    line-height: 0.8rem;
    color: #898b8b;
    margin: 0;
    padding-left: 10px;
    padding-top: 7px;
  }
  .spanTitle{
    width: calc(100% - 40px) !important;
    overflow: hidden;
    word-break: normal;
    overflow-wrap: normal;
    font-size: 14.25px;
    line-height: 1rem;
  }
  .spanSummary{
    display: block;
    font-size: large;
    word-break: normal;
    overflow-wrap: normal;
    font-size: 0.8rem;
    line-height: 0.8rem;
    padding-left: 10px;
  }
  .shareBtn{
    background-color: white;
    padding-left: 3px !important;
  }
</style>
